import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { ReactNode } from "react";
import "./NotificationToast.scss";

export const COOKIE_KEY_PREFIX = "userful-notification-";

const hideFor1Day = (key: string) => Cookies.set(`${COOKIE_KEY_PREFIX}${key}`, "hide", { expires: 1 });
// const hideFor1Hour = (key: string) => Cookies.set(`${COOKIE_KEY_PREFIX}${key}`, "hide", { expires: 1 / 24 });
// const hideFor2Hours = (key: string) => Cookies.set(`${COOKIE_KEY_PREFIX}${key}`, "hide", { expires: 1 / 12 });
const hide = (key: string) => Cookies.set(`${COOKIE_KEY_PREFIX}${key}`, "hide", { expires: 365 });

interface IProps {
    cookieKey?: string;
    content: ReactNode;
    usageLevel?: string | number;
    hideToast?: () => void;
}

export default function NotificationToast({ cookieKey, content, usageLevel, hideToast }: IProps) {
    const { t } = useTranslation();

    const handleHideFor1Day = (e) => {
        e.preventDefault();
        hideFor1Day(cookieKey);
        if (hideToast) hideToast();
    };

    // const handleHideFor1Hour = (e) => {
    //      e.preventDefault();
    //      hideFor1Hour(cookieKey);
    //      if (hideToast) hideToast();
    // }

    // const handleHideFor2Hours = (e) => {
    //      e.preventDefault();
    //      hideFor2Hours(cookieKey);
    //      if (hideToast) hideToast();
    // }

    const handleHide = (e) => {
        e.preventDefault();
        hide(cookieKey);
        if (hideToast) hideToast();
    };

    return (
        <div className="notificationContentContainer">
            {content}
            {cookieKey && (
                <div className="notificationHideActions">
                    {(!usageLevel || usageLevel === 2) && (
                        <>
                            <a href="#" onClick={handleHideFor1Day}>
                                {t("Error.hideForADay")}
                            </a>
                            <a href="#" onClick={handleHide}>
                                {t("Error.hideForever")}
                            </a>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}
